import { echossAxios } from './index';
import type { PaymentHistoryResp } from './memberArea';

export const redeemStoreValueCard = async (token: string, params: Record<string, any>) => {
  try {
    const formData = new FormData();
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    });

    await echossAxios.request({
      url: '/api/member/prepaid-cards/redeem',
      method: 'POST',
      data: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const queryStoreValueCard = async (token: string) => {
  try {
    const { data } = await echossAxios.request({
      url: '/api/member/prepaid-cards/balance',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const queryStoreValueHistory = async (
  token: string,
  params: {
    page?: number;
    rows?: number;
  },
): Promise<PaymentHistoryResp> => {
  try {
    const { data } = await echossAxios.request<PaymentHistoryResp>({
      url: '/api/member/prepaid-cards/history',
      method: 'GET',
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return { data: data.data, meta: data.meta };
  } catch (error: any) {
    console.log(error);
    return { error, data: undefined };
  }
};
